import { IsString, IsNumber, IsOptional } from 'class-validator';

export class CircuitVm {
    @IsString()
    tenant: string;

    @IsString()
    id: string;

    @IsString()
    warehouseId: string;

    @IsString()
    name: string;

    @IsNumber()
    priority: number;

    @IsString()
    @IsOptional()
    teamId?: string;

    @IsString()
    @IsOptional()
    teamName?: string;

    @IsString()
    @IsOptional()
    preparationAreaId?: string;
}
